export default {
  title: 'Reserveringen activeren',
  buttons: {
    cancel: 'Annuleren',
    activate: 'Reserveringen activeren',
  },
};
